import { IconWrapper } from '../runtime';
export default IconWrapper('dragging', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("g", [h("g", [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7 2.49997C7 3.3284 6.32843 3.99997 5.5 3.99997C4.67157 3.99997 4 3.3284 4 2.49997C4 1.67154 4.67157 0.999969 5.5 0.999969C6.32843 0.999969 7 1.67154 7 2.49997ZM7 13.5C7 14.3284 6.32843 15 5.5 15C4.67157 15 4 14.3284 4 13.5C4 12.6715 4.67157 12 5.5 12C6.32843 12 7 12.6715 7 13.5ZM5.5 9.49997C6.32843 9.49997 7 8.8284 7 7.99997C7 7.17154 6.32843 6.49997 5.5 6.49997C4.67157 6.49997 4 7.17154 4 7.99997C4 8.8284 4.67157 9.49997 5.5 9.49997Z",
      "fill": props.colors[0]
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13 2.49997C13 3.3284 12.3284 3.99997 11.5 3.99997C10.6716 3.99997 10 3.3284 10 2.49997C10 1.67154 10.6716 0.999969 11.5 0.999969C12.3284 0.999969 13 1.67154 13 2.49997ZM13 13.5C13 14.3284 12.3284 15 11.5 15C10.6716 15 10 14.3284 10 13.5C10 12.6715 10.6716 12 11.5 12C12.3284 12 13 12.6715 13 13.5ZM11.5 9.49997C12.3284 9.49997 13 8.8284 13 7.99997C13 7.17154 12.3284 6.49997 11.5 6.49997C10.6716 6.49997 10 7.17154 10 7.99997C10 8.8284 10.6716 9.49997 11.5 9.49997Z",
      "fill": props.colors[0]
    }
  })])])]);
});